import TabContentLoading from 'components/molecules/TabContentLoading';
import { FC } from 'react';

const ProjectCustomizationLoadingTemplate: FC = () => {
  return (
    <TabContentLoading />
  );
}

export default ProjectCustomizationLoadingTemplate;